import BaseUrl from "../types/BaseUrl";
import ICampaignID from "../types/ICampaignID";
import Options from "../types/Options";
import CampaignInfoAllContainers from "./containers/containers";

// Class to retrieve campaign UUID from all containers by priority
export default class CampaignID {
  private campaignInfoContainers: CampaignInfoAllContainers;
  private campaignId: ICampaignID;
  private options: Options;

  constructor(baseUrl: BaseUrl, options: Options) {
    this.options = options;
    this.campaignInfoContainers = this.initializeCampaignInfoLoaders(baseUrl, options);
    this.campaignId = this.detect();

    if (this.isValid()) {
      this.store();
    }
  }

  private initializeCampaignInfoLoaders(baseUrl: BaseUrl, options: Options): CampaignInfoAllContainers {
    return new CampaignInfoAllContainers(baseUrl, options);
  }

  private detect(): ICampaignID {
    let campaignId: ICampaignID = null;
    this.campaignInfoContainers.forEach((campaignInfoContainer) => {
      if (this.options.isValidDetector(campaignInfoContainer.containerName)) {
        campaignId = campaignId || campaignInfoContainer.load();
      }
    });

    return campaignId;
  }

  private isValid(): boolean {
    //TODO: Validate the campaignID to make sure it is still running! Currently it's always valid but we remove all storage and reload data from API everytime.
    return !!this.getUUID();
  }

  private store(): void {
    this.campaignInfoContainers.forEach((campaignInfoContainer) => {
      campaignInfoContainer.store(this.get());
    });
  }

  public get(): ICampaignID {
    return this.campaignId;
  }

  public getUUID(): string {
    return this.get() ? this.get().UUID : "merchandising";
  }
}
